//facilities
const FacilitiesModule = () => import('@pages/facilities/FacilitiesModule')
const FacilitiesIndex = () => import('@pages/facilities/FacilitiesIndex')
const ReservedFacilityIndex = () => import('@pages/facilities/bookings/ReservedFacilityIndex')

export default {
    path: 'facilities',
    component: FacilitiesModule,
    children: [
        {
            path: 'facilities-index',
            component: FacilitiesIndex,
            name: 'facilities',
        },
        {
            path: 'admin-reserved-facilities',
            component: ReservedFacilityIndex,
            name: 'adminReservedFacilities',
        },
    ],
}
